// @flow
import { authInstance } from '../../firebase';
import { httpRequest, httpRequestWithToken, getSaasBackendEndpoint } from '../../utils/http';

const fetchCustomToken = async () => {
  if (!authInstance.currentUser) return '';

  const url = `${getSaasBackendEndpoint()}/api/v1/users/me/customToken`;
  const idToken = await authInstance.currentUser.getIdToken();

  const res = await httpRequestWithToken({
    url,
    method: 'POST',
    payload: { idToken },
  });

  const { data } = res;
  return data.customToken || '';
};

const createOrganization = async ({
  type,
  name,
  role,
  placeId,
}: {
  type: string,
  name: string,
  role: string,
  placeId?: string,
}) =>
  httpRequestWithToken({
    url: `${getSaasBackendEndpoint()}/api/v1/organization`,
    method: 'POST',
    payload: {
      type,
      name,
      role,
      placeId,
    },
  });

const getOrCreateUser = async (data: Object) =>
  // NOTE: if email is not verified this will throw 403
  httpRequestWithToken({
    url: `${getSaasBackendEndpoint()}/api/v1/users/me`,
    method: 'PATCH',
    payload: data,
  });

const getUser = async (language: string) =>
  httpRequestWithToken({
    url: `${getSaasBackendEndpoint()}/api/v1/users/me?language=${language}`,
    method: 'GET',
  });

const createLicence = async ({ licence, language, trial }: { licence: Object, language: string, trial: Object }) => {
  const payload = {
    ...licence,
    language,
    trial,
  };

  if (licence.type === 'magicLink') {
    return httpRequest({
      url: `${getSaasBackendEndpoint()}/api/v1/licences/magicLink`,
      method: 'POST',
      payload,
    });
  } else {
    return httpRequestWithToken({
      url: `${getSaasBackendEndpoint()}/api/v1/licences`,
      method: 'POST',
      payload,
    });
  }
};

const deleteLicence = ({ id, licence, language }: { id: string, licence: Object, language: string }) =>
  httpRequestWithToken({
    url: `${getSaasBackendEndpoint()}/api/v1/licences/${id}`,
    method: 'DELETE',
    payload: {
      ...licence,
      language,
    },
  });

const updateLicence = async ({
  id,
  licence,
  recipient,
  language,
}: {
  id: string,
  licence: Object,
  recipient: Object,
  language: string,
}) =>
  httpRequestWithToken({
    url: `${getSaasBackendEndpoint()}/api/v1/licences/${id}`,
    method: 'PATCH',
    payload: {
      ...licence,
      recipient,
      language,
    },
  });

export const getStripePlan = async ({ id, language }: { id: string, language: string }) =>
  httpRequestWithToken({
    url: `${getSaasBackendEndpoint()}/api/v1/stripe/plan/${id}?language=${language}`,
    method: 'GET',
  });

export const users = {
  fetchCustomToken,
  getOrCreateUser,
  getUser,
};

export const organizations = {
  createOrganization,
};

export const licences = {
  createLicence,
  deleteLicence,
  updateLicence,
};
